import styled from 'styled-components';

export const Card = styled.div`
  background-color: #fcfcfc;
  border-radius: 5px;
  padding: 35px;
  margin: 30px 20px;
  min-height: calc(100vh - 200px);
`;
